import type { FieldPolicy } from "@apollo/client"

export const getCadastreOwnerships: FieldPolicy = {
  keyArgs(args) {
    const { cadastreId } = args.input
    return `${cadastreId}`
  }
}
